import * as actions from './actions';

import { ActionType, getType } from 'typesafe-actions';

interface IState {
  readonly selectedDate: any;
  readonly selectedMonth: any;
  readonly selectedYear: any;
}

const initialState: IState = {
  selectedDate: null,
  selectedMonth: null,
  selectedYear: null,
};

type CalendarActions = ActionType<typeof actions>;

export default (state: Mutable<IState> = initialState, action: CalendarActions): IState => {
  switch (action.type) {
    case getType(actions.updatePagesHistoryCalendarSelectedDate): {
      state.selectedDate = action.payload;
      break;
    }
    case getType(actions.updatePagesCalendarSelectedMonth): {
      state.selectedMonth = action.payload;
      break;
    }
    case getType(actions.updatePagesCalendarSelectedYear): {
      state.selectedYear = action.payload;
      break;
    }
    case getType(actions.resetPagesCalendarState): {
      return initialState;
    }
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryCalendar/reducer.ts